import "../pages/css/App.css";
import "../pages/css/WhiskyCreate.css";
import frontendLogger from "../utils/frontendLogger.js";
import useAuthUser from "../hooks/useAuthUser.js";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { logout } from "../hooks/logout.js";
import { assignWhisky } from "../hooks/forwardToAssign.js";
import { API_BASE_URL } from "../app_config.js";

function WhiskyCreate() {
  const { userId, loading, error } = useAuthUser();
  const [whiskyName, setWhiskyName] = useState("");
  const [distilleryId, setDistilleryId] = useState("");
  const [distilleries, setDistilleries] = useState([]);
  const [alcoholStrength, setAlcoholStrength] = useState("");
  const [whiskyType, setWhiskyType] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const handleBackToStart = () => {
    navigate("/main");
  };
  const handleSaveWhisky = async (e) => {
    e.preventDefault();

    if (!userId) {
      setErrorMessage(
        "Benutzer-ID noch nicht geladen. Bitte versuchen Sie es später.",
      );
      return;
    }

    setErrorMessage("");
    setSuccessMessage("");

    const whiskyData = {
      name: whiskyName,
      distillery_id: parseInt(distilleryId, 10),
      alcohol_percent: parseFloat(alcoholStrength),
      type: whiskyType,
    };

    frontendLogger.info("Speichere Whisky:", whiskyData);

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/api/whisky/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(whiskyData),
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Fehler beim Speichern des Whiskys: ${text}`);
      }

      const data = await response.json();
      frontendLogger.info("Whisky gespeichert:", data);

      setSuccessMessage("Whisky erfolgreich gespeichert!");
    } catch (error) {
      frontendLogger.error("Diesen Whisky gibt es bereits", error);
      setErrorMessage(error.message);
    }
  };

  useEffect(() => {
    const fetchDistilleries = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/distilleries`);

        if (!response.ok) {
          throw new Error("Fehler beim Laden der Destillerien");
        }

        const data = await response.json();
        setDistilleries(data);
      } catch (err) {
        frontendLogger.error("Fehler beim Laden der Destillerien:", err);
        setErrorMessage("Destillerien konnten nicht geladen werden");
      }
    };

    fetchDistilleries();
  }, []);

  if (loading) {
    return (
      <div className="App">
        <h1 className="header">Lade...</h1>
      </div>
    );
  }

  if (error) {
    return (
      <div className="App">
        <h1 className="header">{error}</h1>
      </div>
    );
  }

  return (
    <div className="page-layout">
      <div className="menu-container">
        <div className="title-box">
          <p>Willkommen bei DRAM</p>
        </div>
        <div className="menu-box">
          <h1>Neuen Whisky anlegen</h1>
        </div>

        <nav className="nav">
          <button className="nav-button" onClick={handleBackToStart}>
            Startseite
          </button>

          <button
            className="nav-button"
            type="submit"
            form="whiskyForm"
            disabled={!userId}
          >
            Whisky speichern
          </button>

          <button className="nav-button" onClick={() => assignWhisky(navigate)}>
            Whisky zuordnen
          </button>

          <button className="nav-button" onClick={() => logout(navigate)}>
            Abmelden
          </button>
        </nav>
        <img
          src={require("../assets/logo.png")}
          alt="Versionsinformationen anzeigen"
          className="whisky-image"
          role="button"
          tabIndex={0}
        />
      </div>

      <div className="whisky-form-group">
        {successMessage && (
          <div className="success-message">{successMessage}</div>
        )}
        {errorMessage && <div className="error-message">{errorMessage}</div>}

        <form id="whiskyForm" onSubmit={handleSaveWhisky}>
          <label htmlFor="whiskyName">Whisky-Name:</label>
          <input
            type="text"
            id="whiskyName"
            value={whiskyName}
            onChange={(e) => setWhiskyName(e.target.value)}
            name="whiskyName"
            placeholder="Bitte gib einen Whisky-Namen an"
            required
          />

          <label htmlFor="distilleryId">Destillerie:</label>
          <select
            id="distilleryId"
            value={distilleryId}
            onChange={(e) => setDistilleryId(e.target.value)}
            required
          >
            <option value="">Bitte wählen</option>

            {distilleries.map((distillery) => (
              <option key={distillery.id} value={distillery.id}>
                {distillery.name}
              </option>
            ))}
          </select>

          <label htmlFor="whiskyType">Typ:</label>
          <select
            value={whiskyType}
            onChange={(e) => setWhiskyType(e.target.value)}
          >
            <option value="">Bitte wählen</option>
            <option value="rauchig">Rauchig</option>
            <option value="fruchtig">Fruchtig</option>
          </select>

          <label htmlFor="alcoholStrength">Alkoholgehalt in %:</label>
          <input
            type="number"
            step="0.1"
            id="alcoholStrength"
            value={alcoholStrength}
            onChange={(e) => setAlcoholStrength(e.target.value)}
            name="alcoholStrength"
            placeholder="Format z.B. 40.0 ohne % Zeichen"
            required
          />
        </form>
      </div>
    </div>
  );
}

export default WhiskyCreate;
